import { RegionSearchFilterDTO, SearchFilterDTO } from "../../types";

export function isRegionSearchDTO(filter: SearchFilterDTO): filter is RegionSearchFilterDTO {
  return filter.id === "region-id";
}
